import React from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/config';

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = React.useState(true);
  const [authorized, setAuthorized] = React.useState(false);

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
          if (userDoc.exists() && (userDoc.data().role === 'admin' || userDoc.data().role === 'staff')) {
            setAuthorized(true);
          } else {
            console.warn(`User signed in but role check failed: ${currentUser.uid}`);
            await signOut(auth);
            setAuthorized(false);
          }
        } catch (err) {
          console.error('Auth role check failed:', err);
          setAuthorized(false);
        }
      } else {
        setAuthorized(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-charcoal-dark text-slate-300">
        <div className="text-center chrome-panel border border-white/5 rounded-lg px-8 py-6">
          <p className="text-lg font-medium uppercase tracking-wider text-banana-yellow">
            Checking access…
          </p>
          <p className="text-sm text-slate-500 mt-2">Please wait</p>
        </div>
      </div>
    );
  }

  return authorized ? children : <Navigate to="/admin/login" replace />;
};

export default ProtectedRoute;
